export default __webpack_public_path__ + "static/media/event.b1cd05a0.png";